(function () {
  document.querySelectorAll('[data-gg-clubs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-gg-clubs-tab]');
    var groups = root.querySelectorAll('[data-gg-clubs-group]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var league = tab.getAttribute('data-gg-clubs-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        groups.forEach(function (group) {
          group.hidden = league !== '' && group.getAttribute('data-gg-clubs-group') !== league;
        });
      });
    });
  });
})();
